import { AdCampaignTypeEnum } from 'domain/media/types';

export const AD_TYPE_ART = {
  [AdCampaignTypeEnum.Interval]: '/assets/img/campaigns/stepper_interval.png',
  [AdCampaignTypeEnum.ExactTime]: '/assets/img/campaigns/stepper_exact_time.png',
  [AdCampaignTypeEnum.Period]: '/assets/img/campaigns/stepper_period.png',
} as const;

export const INSTANT_AD_TYPE_ART = {
  campaign: '/assets/img/campaigns/stepper_instant_campaign.png',
  device: '/assets/img/campaigns/stepper_instant_device.png',
} as const;
